import React from 'react';
import { Alert, Button } from 'react-bootstrap';
import { GOOGLE_LOGIN_URL } from '../api/client';

const LoginScreen: React.FC<{ notice?: string }> = ({ notice }) => (
  <div className="login-hero">
    <div className="surface login-card">
      <div className="navbar-brand-mark mx-auto mb-3" aria-hidden="true">T</div>
      <h1 className="h3 mb-2">Trainer</h1>
      <p className="muted mb-4">Your running history, health and personal bests, from Garmin Connect.</p>
      {notice && <Alert variant="warning" className="py-2">{notice}</Alert>}
      <Button
        variant="primary"
        size="lg"
        className="w-100"
        onClick={() => {
          window.location.href = GOOGLE_LOGIN_URL;
        }}
      >
        Sign in with Google
      </Button>
      <p className="muted small mt-3 mb-0">Only Google accounts you are allowed to use can sign in.</p>
    </div>
  </div>
);

export default LoginScreen;
